import { PermissionAllowModel } from 'models/hook/permission.model';

export const BE_DEFINES = {
  HUB_TYPE: {
    BILL_ACCEPTOR: 1,
    REMOTE: 0,
  },
  REPORT_REVENUE_SHOOTING_TYPES: {
    REVENUE: 1,
    SHOOTING_COUNT: 2,
  },
  DEPOSIT_MACHINE_TYPE: {
    MONEY_IN: 1,
    MONEY_OUT: 2,
  },
  BOOTH_TYPE: {
    NORMAL: 1,
    ROBOT_ARM: 2,
    OVER_HEAD: 3,
  },
  SCREEN_TYPE: {
    HORIZONTAL: 1,
    VERTICAL: 2,
  },
  BOOTH_VERSION_TYPE: {
    UPDATE_SYNC: 1, // cập nhật service đồng bộ
    UPDATE_BE_API: 2, // cập nhật api BE
  },
  BILL_ACCEPTOR_TYPE: {
    ICT: 'ICT',
    TOP: 'TOP',
  },
  GENDER: {
    MALE: '1',
    FEMALE: '2',
    MALE_TEXT: 'male',
  },
};

export enum ROLE_TYPES {
  Admin = 'Admin', // Admin
  Manager = 'Manager', // Quản lý vận hành
  Franchiser = 'Franchiser', // Chủ Nhượng quyền
  FranchiserManager = 'FranchiserManager', // Quản lý cửa hàng nhượng quyền
  BoothReceptionist = 'BoothReceptionist', // Nhân viên cửa hàng
  Sale = 'Sale', // Bán hàng
  Accountant = 'Accountant', // Kế toán
  Marketing = 'Marketing', // Marketing
  ITSupport = 'ITSupport', // IT Support
  Buyer = 'Buyer', // Mua máy
}

export const ROLE_LEVEL = {
  [ROLE_TYPES.Admin]: 1,
  [ROLE_TYPES.Manager]: 2,
  [ROLE_TYPES.Sale]: 3,
  [ROLE_TYPES.Accountant]: 3,
  [ROLE_TYPES.Marketing]: 3,
  [ROLE_TYPES.ITSupport]: 3,
  [ROLE_TYPES.Buyer]: 3,
  [ROLE_TYPES.Franchiser]: 3,
  [ROLE_TYPES.FranchiserManager]: 4,
  [ROLE_TYPES.BoothReceptionist]: 5,
};

export const NOT_HAVE_PERMISSION: PermissionAllowModel = {
  canView: false,
  canUpdate: false,
  canDelete: false,
  canSeeBoothId: false,
  canUpdateBoothVersion: false,
  canRefund: false,
  disableNewNotUpdate: true,
};

export const HAVE_ALL_PERMISSION: PermissionAllowModel = {
  canView: true,
  canUpdate: true,
  canDelete: true,
  canSeeBoothId: true,
  canUpdateBoothVersion: true,
  canRefund: true,
  disableNewNotUpdate: false,
};
